// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"787":"145b72fd","897":"85d87f2f"}[chunkId] + ".chunk.js";
};